interface FormField {
  id: number;
  label: string;
  type: string;
  required: boolean;
  typeCheck: string;
}

export const validateField = (field: FormField, value: any): string => {
  // Handle location/country type
  if (field.type === "country") {
    if (field.required && typeof value === "object") {
      if (!value.country) return "Country is required";
      if (!value.state) return "State is required";
      if (!value.city) return "City is required";
    }
    return "";
  }

  // Handle all other types as string
  if (field.required && !value?.trim()) {
    return `${field.label} is required`;
  }

  if (value && field.type === "tel") {
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(value.replace(/[-()\s]/g, ""))) {
      return "Please enter a valid 10-digit phone number";
    }
  }

  if (value && field.label.toLowerCase().includes("email")) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      return "Please enter a valid email address";
    }
  }

  return "";
};

export const validateAllFields = (
  fields: FormField[],
  formData: { [key: string]: string }
): { [key: string]: string } => {
  const errors: { [key: string]: string } = {};

  fields.forEach((field) => {
    const value = formData[field.id] || "";
    const error = validateField(field, value);
    if (error) {
      errors[field.id] = error;
    }
  });

  return errors;
};
